import classnames from 'classnames';

import styles from './MenuLink.module.scss';
import { Props } from './MenuLink.types';

const MenuLink = ({ label, icon, onClick, selected }: Props) => {
  const Icon = icon;

  return (
    <li className={styles.container} onClick={onClick}>
      <div className={classnames(styles.row, { [styles.selected]: selected })}>
        <Icon height={22} className={classnames(styles.icon)} />
        <div className={styles.textTruncate}>{label}</div>
      </div>
    </li>
  );
};

export default MenuLink;
